import React, { useState, useEffect } from "react";
import Checked from "../assets/images/checked.png";
import styled from "styled-components";
import { useDropzone } from "react-dropzone";
import { isEmpty} from "lodash";
import { base64toBlob, detectMimeType, getKycDocType } from "utils";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import Alert from "components/atoms/Alert";
import closeIcon from "../assets/svg/close_x.svg";


const UploadFile = styled.div`
  width: auto;
  height: 50px;
  background: #ffffff;
  border: 1px dashed #dfe0eb;
  box-sizing: border-box;
  border-radius: 5px;
  display: flex;
  align-items: center;
`;

function KycForms(props) {
  const reader = new FileReader();
  const [openModal, setOpenModal] = useState(false);
  const [image, setImage] = useState("");
  const {
    data,
    itemKey, //passing key as itemKey to avoid conflict with the key prop in React
    value,
    handleValue,
    setValue,
    field,
    setField,
    addField,
    setAddField,
    handleRemoveAddedField,
    removeFieldHandler,
  } = props;

  const { getRootProps, getInputProps, acceptedFiles, fileRejections, open } =
    useDropzone({
      // accept: "image/*, application/pdf",
      accept: "application/pdf",
      noClick: true,
      noKeyboard: true,
      maxSize: 1000 * 1000 * 2,
    });

  useEffect(() => {
    if (value) {
      if (Array.isArray(value)) {
        value.map((data) => {
          if (data.documentType === "TEXT") {
            setField({ ...field, [data.fieldName]: data.rawFile });
          } else {
            setField({ ...field, [data.fieldName]: data.rawFile });
          }
        });
      }
    }
  }, [value]);

  const transformKycDocuments = (
    docs,
    fieldName,
    currentData,
    fieldValue,
    type = "TEXT"
  ) => {
    const copy = JSON.parse(JSON.stringify(docs));
    let index;
    const exists = docs.find((item, i) => {
      index = i;
      return item.fieldName == fieldName;
    });
    if (exists) {
      if (type === "NONTEXT") {
        const d = {
          fieldName: currentData.fieldName,
          documentType: currentData.documentType,
          rawFile: fieldValue,
          // required: currentData.required
        };
        copy[index] = d;
        setValue(copy);
      } else {
        let d = {
          fieldName: currentData.fieldName,
          documentType: currentData.documentType,
          kycRecordUpdate: fieldValue,
          // required: currentData.required
        };

        copy[index] = d;
        setValue(copy);
      }
    } else {
      if (type === "NONTEXT") {
        let d = {
          fieldName: currentData.fieldName,
          documentType: currentData.documentType,
          rawFile: fieldValue,
          // required: currentData.required
        };
        copy.push(d);
        setValue(copy);
      } else {
        let d = {
          fieldName: currentData.fieldName,
          documentType: currentData.documentType,
          kycRecordUpdate: fieldValue,
          // required: currentData.required
        };
        copy.push(d);
        setValue(copy);
      }
    }
  };

  const setKycValues = (fieldValue, fieldName, currentData) => {
    if (value && value.length > 0) {
      transformKycDocuments(value, fieldName, currentData, fieldValue, "TEXT");
    } else {
      setValue([
        {
          fieldName: currentData.fieldName,
          documentType: currentData.documentType,
          kycRecordUpdate: fieldValue,
          required: currentData.required,
        },
      ]);
    }
  };

  useEffect(() => {
    acceptedFiles.map((file) => {
      if (file) {
        if (file.size > 5 * 1024 * 1024) {
          Alert("error", "Maximum of 5MB is allowed");
          return;
        }
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          if (value && value.length > 0) {
            transformKycDocuments(
              value,
              data.fieldName,
              data,
              reader.result,
              "NONTEXT"
            );
            Alert("success", "File was successfully uploaded");
          } else {
            setValue([
              {
                fieldName: data.fieldName,
                documentType: data.documentType,
                rawFile: reader.result,
              },
            ]);
          }
        };
      }
    });
  }, [acceptedFiles]);

  useEffect(() => {
    fileRejections.map((file) => {
      if (file && file.errors) {
        if (file.errors[0].code === "file-too-large") {
          Alert(
            "error",
            "Sorry! Your document is larger than 2 Megabytes. Kindly reduce the file size and re-upload."
          );
        }
      }
    });
  }, [fileRejections]);

  const isAvailable = field && Object.keys(field).indexOf(data.fieldName) > -1;
  const requiredField = ["PROFILED"].indexOf(data.status) > -1;

  const previewFile = (d) => {
    try {
      const file = value.find((item) => item.fieldName === d.fieldName);
      if (detectMimeType(file.rawFile).indexOf("image") !== -1) {
        setImage(file.rawFile);
        setOpenModal(true);
      } else if (detectMimeType(file.rawFile).indexOf("pdf") !== -1) {
        var blob = base64toBlob(
          encodeURI(
            file.rawFile.replace(/^data:application\/[a-z]+;base64,/, "")
          )
        );
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, "pdfBase64.pdf");
        }else{
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        }
      }
    } catch (e) {
      Alert("error", "Unable to preview file at the moment");
    }
  };

  const previewLink = (d) => {
    try {
      if (getKycDocType(d) === "IMAGE") {
        setImage(d.kycDocumentUrl);
        setOpenModal(true);
      } else if (getKycDocType(d) === "PDF") {
        window.open(encodeURI(d.kycDocumentUrl));
      }
    } catch (e) {
      Alert("error", "Unable to preview file at the moment");
    }
  };
  return (
    <div className="sbt-kyc">
      {openModal && (
          <Lightbox
            aria-label="lightbox"
            mainSrc={image}
            onCloseRequest={() => setOpenModal(false)}
          />
      )}
      {!requiredField && (
        <UploadFile className="justify-between p-3 mb-3">
          <span className="flex items-center">
            <img src={Checked} height="14" />
            <span className="pl-2">{data.fieldName}</span>
          </span>
          <span
            className="cursor-pointer seerbit-color"
            onClick={() => previewLink(data)}
          >
            PREVIEW
          </span>
        </UploadFile>
      )}
      {data.documentType === "TEXT" &&
        data.status !== "APPROVED" &&
        requiredField && (
          <div className="flex flex-col-reverse gap-3 mb-3" key={itemKey}>
            <input
              autoComplete="on"
              style={{ display: "none" }}
              id="fake-hidden-input-to-stop-google-address-lookup"
            />
            <div className="flex flex-col-reverse gap-3 mb-3 form-outline">
              <input
                autoComplete="off"
                name={data.fieldName}
                type="text"
                id={data.fieldName}
                className={
                  value && isAvailable && field[data.fieldName] !== ""
                    ? `form-control hasText`
                    : `form-control seerbit-text p-2 rounded-lg border border-gray-300`
                }
                onChange={(e) => {
                  setKycValues(e.target.value, data.fieldName, data);
                }}
                value={
                  value && isAvailable
                    ? field[data.fieldName]
                    : data.kycRecordUpdate
                }
                required
              />
              <label className="form-label" htmlFor={`${data.fieldName}`}>
                {data.fieldName.replace("_", " ")}
              </label>
            </div>
          </div>
        )}
      {["IMAGE", "PDF"].indexOf(data.documentType) > -1 &&
        data.status !== "APPROVED" &&
        requiredField &&
        isEmpty(data.kycDocumentUrl) && (
          <div className="mb-3" key={itemKey}>
            <div className="flex items-center justify-between gap-5 my-1 file-label">
              <div>
                <span className="text-xs font-bold">{data.fieldName}</span>{" "}
                {data.required && (
                  <span style={{ color: "rgb(255 34 0)" }} className="font-16">
                    *
                  </span>
                )}
              </div>
              {!data.required && (
                <span
                  className="flex items-center gap-1 cursor-pointer"
                  onClick={() => {
                    setAddField(false);
                    handleRemoveAddedField();
                    removeFieldHandler();
                  }}
                >
                  <span className="!text-[10px]">Remove</span>
                  <img src={closeIcon} alt="close" className="w-3 h-3" />
                </span>
              )}
            </div>
            <div {...getRootProps({ className: "dropzone" })}>
              <input {...getInputProps()} />
              <UploadFile
                style={{
                  border: props.emptyUpload
                    ? "0.5px solid #ff0000"
                    : "1px dashed rgb(223, 224, 235)",
                }}
              >
                {value && isAvailable ? (
                  <div className="flex items-center justify-between w-full p-3">
                    <span className="file-content">
                      <span
                        data-testid="preview-btn"
                        className="text-sm cursor-pointer text-Primary"
                        onClick={() => previewFile(data)}
                      >
                        PREVIEW
                      </span>
                    </span>
                    <span
                      className="text-xs cursor-pointer text-Primary"
                      onClick={open}
                    >
                      Replace
                    </span>
                  </div>
                ) : data.status === "PROFILED" ? (
                  <div className="px-2 pt-1">
                    <span className="text-xs font-normal file-content">
                      Drop file here or{" "}
                      <span
                        className="cursor-pointer text-primary text-Primary hover:underline"
                        onClick={open}
                      >
                        browse files
                      </span>{" "}
                      from your computer
                    </span>
                  </div>
                ) : (
                  <div className="flex items-center justify-between p-3 w-100">
                    <span
                      className="file-content"
                      onClick={() => previewLink(data)}
                    >
                      <img src={Checked} height="8" alt="checked" />{" "}
                      {data.fieldName}
                    </span>
                    <span
                      className="cursor-pointer font-10 text-Blue"
                      onClick={open}
                    >
                      Replace
                    </span>
                  </div>
                )}
              </UploadFile>
              <div className="text-xs d-flex justify-content-end">
                *Maximum file size is 2MB
              </div>
            </div>
          </div>
        )}
    </div>
  );
}
export default KycForms;